<template>
  <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          v-model="computedDateFormatted"
          :label=label
          persistent-hint
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          :rules="[requiredRules()]"
      ></v-text-field>
    </template>
    <v-date-picker
        v-model="dates"
        :first-day-of-week="1"
        full-width
        locale="ru-ru"
        no-title
        range
    ></v-date-picker>
  </v-menu>

</template>

<script>
import { cloneDeep } from 'lodash'
export default {
  props:['value','label','validate'],
  data: () => ({
    dates: [],
    menu: false,
    requiredRules(){
      if (!this.validate){return true || ""}
      let date1 = this.formatDate(this.dates[0])
      let date2 = this.formatDate(this.dates[1])
      if (date1==null||date2==null) return false || `Поле не заполнено`
      return true || `Поле не заполнено`
    },


  }),
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
  },
  computed: {
    computedDateFormatted () {
      let date1 = this.formatDate(this.dates[0])
      let date2 = this.formatDate(this.dates[1])
      if (date1==null) date1 = '?'
      if (date2==null) date2 = '?'
      return `${date1} - ${date2}`
    },
  },
  watch: {
    dates (val) {
      if (this.dates[0]!=null && this.dates[1]!=null && this.dates[0]>this.dates[1]){
        const d0 = this.dates[0]
        if (this.dates[0]>this.dates[1]) {
          this.dates[0] = this.dates[1]
          this.dates[1] = d0
        }
      }
      this.$emit('change', val)
    },
  },
  created() {
    this.dates = cloneDeep(this.value)
  }
}
</script>
